import * as React from 'react'
import Svg, { Path, type SvgProps } from 'react-native-svg'

function LinkIcon(props: SvgProps) {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        d="M11 13.5s.177.14.684.417a4.023 4.023 0 004.773-.686l2.414-2.414a4.023 4.023 0 00-5.688-5.688l-1.384 1.376M13 10.5s-.177-.157-.684-.433a4.023 4.023 0 00-4.773.686l-2.414 2.414a4.023 4.023 0 005.688 5.688l1.376-1.376"
        stroke={props.color ?? '#152438'}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

export default LinkIcon
